import * as React from 'react';
import { observer } from 'mobx-react';
import { AppFactory } from '@app/app-factory';
import { useNavigate } from 'react-router-dom';
import { learnHomePath, subscribePath } from 'components/nav/path-helpers';
import { PurchaseFlowDisabled } from 'components/account/account-cta/purchase-flow-disabled';
import { Story } from '@core/models/story-manager/story';
import { CenterColumnLayout } from 'components/layouts/center-column-layout';
import { styled } from '@naan/stitches.config';
import { LockSmallIcon } from '@naan/icons/lock-icon';
import { Button } from '@naan/primitives/button';

import __ from '@core/lib/localization';

const Wrapper = styled('div', {
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px 16px 32px 16px',
  maxWidth: '600px',
  margin: '0 auto',

  '& > .title': {
    textStyle: 'small-heading',
    display: 'flex',
    marginBottom: '12px',
    alignItems: 'center',
    gap: '4px',
  },

  '& > .buttons': {
    display: 'flex',
    marginTop: '16px',
    '& > * + *': {
      marginLeft: 8,
    },
  },
});

export const StoryLockedActions = observer(({ story }: { story: Story }) => {
  const navigate = useNavigate();

  if (!story.locked) {
    return null;
  }

  const { userManager } = AppFactory.root;

  // const ActionButton = (props: ButtonProps) => (
  //   <Responsive
  //     renderDefault={() => <Button css={{ flex: 1 }} {...props} />}
  //     renderMediumAndUp={() => <Button {...props} />}
  //   />
  // );

  return (
    <CenterColumnLayout backgroundColor="#ffeded">
      <Wrapper>
        <h3 className="title">
          <span className="icon">
            <LockSmallIcon />
          </span>
          {__('Subscribers only', 'story.subscribersOnly')}
        </h3>
        <p>
          {__(
            'You can listen to all Radio Ambulante stories and access the transcripts for free at radioambulante.org',
            'story.youCanListenToAllRadioAmbulanteStories'
          )}
        </p>
        <div className="buttons">
          <Button
            onClick={() => navigate(learnHomePath())}
            presentation="grayLight"
            label={__('View sample stories', 'story.viewSampleStories')}
          />
          {userManager.purchaseFlowDisabled ? (
            <PurchaseFlowDisabled />
          ) : (
            <Button
              onClick={() => navigate(subscribePath())}
              presentation="teal"
              label={__('Subscribe', 'common.subscribe')}
            />
          )}
        </div>
      </Wrapper>
    </CenterColumnLayout>
  );
});
